import Stimulus from "stimulus_init"
import ToggleController from "controllers/toggle_controller"

// Content pages load the content bundle instead of application, so register
// only the controllers their markup uses here, keeping the reader bundle small.
Stimulus.register("toggle", ToggleController)
